interface Props {
  title?: React.ReactNode;
  left: React.ReactNode;
  right: React.ReactNode;
  loading: boolean;
  onToProducts?: () => void;
  onBack?: () => void;
  onNext?: () => void;
}

import { Footer } from '@/components/elements/footer/footer.component';
import Navbar from '@/components/elements/navbar/navbar.component';
import { Topbar } from '@/components/elements/topbar/topbar.component';
import { Loader } from '@/components/ui/loader/loader.component';
import { useDimensions } from '@/hooks/use-dimensions.hook';
import { useMemo, useRef } from 'react';

const TailoringLayout = ({
  title,
  left,
  right,
  loading,
  onBack: handleBack,
  onToProducts: handleToProducts,
  onNext: handleNext,
}: Props) => {
  const navigationRef = useRef<HTMLDivElement>(null);
  const { width: windowWidth, height: windowHeight } = useDimensions();
  const navigationHeight = navigationRef.current?.clientHeight || 0;

  const leftContainerWidth = useMemo(() => windowWidth / 3 + windowWidth / 3 - 80 - 24, [windowWidth]);
  const rightContainerWidth = useMemo(() => windowWidth / 3 - 80 + 4, [windowWidth]);
  const rightHeight = useMemo(() => windowHeight - navigationHeight - 80, [windowHeight, navigationHeight]);

  return (
    <div>
      <div ref={navigationRef} className="fixed top-0 left-0 right-0 z-10">
        <Navbar />
        <Topbar onNext={handleNext} onToProducts={handleToProducts} onBack={handleBack} />
        {!loading && <div>{title}</div>}
      </div>
      <div className="mx-19 my-9 mt-[200px]">
        {loading && <Loader fullWidth />}
        {!loading && (
          <>
            <div
              style={{
                width: leftContainerWidth,
              }}
            >
              {left}
            </div>
            <div
              style={{
                position: 'fixed',
                top: '200px',
                right: '80px',
                overflowY: 'scroll',
                padding: '0 4px',
                height: rightHeight,
                width: rightContainerWidth,
              }}
            >
              {right}
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default TailoringLayout;
